import { render, staticRenderFns } from "./OctDialog.vue?vue&type=template&id=10f13ff6&scoped=true&"
import script from "./OctDialog.vue?vue&type=script&lang=js&"
export * from "./OctDialog.vue?vue&type=script&lang=js&"
import style0 from "./OctDialog.vue?vue&type=style&index=0&id=10f13ff6&scoped=true&lang=scss&"
import style1 from "./OctDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f13ff6",
  null
  
)

export default component.exports